import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=74affaf9&scoped=true"
import script from "./NoticePopup.vue?vue&type=script&lang=js"
export * from "./NoticePopup.vue?vue&type=script&lang=js"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=74affaf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74affaf9",
  null
  
)

export default component.exports